<template>
  <div class="uv-card">
    <div class="uv-card-body">
      <h3 class="uv-card-title">Beneficios del plan - {{ planData.Nomb }} {{ planData.Cve }}</h3>
      <v-row class="mt-2">
        <v-col col="12" md="4">
          <v-card elevation="2" rounded="xl">
            <v-card-title> Agregar Beneficios </v-card-title>
            <v-card-text>
              <v-select v-model="tipoBeneficio" :items="beneficiosType">

              </v-select>

            </v-card-text>
            <!-- seccion beneficios tarifas -->
            <v-card-text v-if="tipoBeneficio == 'RVA'">
              <v-row>
                <v-col md="12">
                  <h5>Beneficios de tarifas</h5>
                  <v-select v-model="beneficioTarifas.RVA_Departamento" :items="RVA_Departamentos" @change="
                    getTarifarios(beneficioTarifas.RVA_Departamento);
                  getSubcategorias(beneficioTarifas.RVA_Departamento);
                  " label="Departamentos Reserva"></v-select>
                </v-col>
                <v-col md="6">
                  <v-select v-model="beneficioTarifas.RVA_Tarifario" :items="Catalogos.tarifarios"
                    label="Tarifarios"></v-select>
                </v-col>
                <v-col md="6">
                  <v-select v-model="beneficioTarifas.RVA_Subcategoria" :items="Catalogos.subcategorias" item-value="id"
                    item-text="Nombre" label="Categoria de tarifas"></v-select>
                </v-col>
                <v-col>
                  <v-switch inset v-model="beneficioTarifas.EsInvitado" :label="'Tarifa invitados'"></v-switch>
                  <v-switch inset v-model="beneficioTarifas.Ilimitado" :label="'Ilimitado'"></v-switch>
                  <v-text-field v-if="!beneficioTarifas.Ilimitado" v-model="beneficioTarifas.Cantidad" type="number"
                    label="Cantidad" dense required></v-text-field>
                </v-col>
                <v-btn outlined @click="addToBeneficios('RVA')" color="green" dark block>
                  Agregar
                </v-btn>
              </v-row>
            </v-card-text>
            <!-- end seccion beneficios tarifas -->
            <!-- seccion beneficios consumibles -->
            <v-card-text v-if="tipoBeneficio == 'CON'">
              <v-row>
                <v-col cols="12" md="12">
                  <h5>Beneficios consumibles</h5>
                  <v-autocomplete label="Producto o Servicio" v-model="beneficioConsumible.PDV_Producto"
                    :items="PDV_Productos"></v-autocomplete>
                </v-col>
                <v-col cols="12" md="12">
                  <v-select v-model="beneficioConsumible.Periodo" label="Periodo de Pago" :items="comp_periodos"
                    item-text="Nombre" item-value="Id">
                  </v-select>
                  <v-switch v-model="beneficioConsumible.Ilimitado" inset :label="'Ilimitado'"></v-switch>
                  <v-text-field v-if="!beneficioConsumible.Ilimitado" v-model="beneficioConsumible.Cantidad"
                    type="number" label="Cantidad" dense required></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="beneficioConsumible.Precio.C" type="number" label="Costo" dense
                    required></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select :items="Catalogos.monedas" item-value="id" item-text="Nombre"
                    v-model="beneficioConsumible.Precio.M" label="Moneda" dense required></v-select>
                </v-col>
                <v-btn outlined @click="addToBeneficios('CON')" color="green" dark block>
                  Agregar
                </v-btn>
              </v-row>
            </v-card-text>
            <!-- end seccion beneficios consumibles -->
            <!-- seccion beneficios promociones -->
            <v-card-text v-if="tipoBeneficio == 'PRO'">
              <v-row>
                <v-col md="12">
                  <h5>Beneficios Promociones</h5>
                  <v-autocomplete label="Promoción" v-model="beneficioPromociones.Promocion" item-value="id"
                    item-text="Nombre" :items="Catalogos.promociones">
                  </v-autocomplete>
                </v-col>
                <v-col md="12">
                  <v-switch inset v-model="beneficioPromociones.Ilimitado" :label="'Ilimitado'"></v-switch>
                  <v-text-field v-if="!beneficioPromociones.Ilimitado" v-model="beneficioPromociones.Cantidad"
                    type="number" label="Cantidad" dense required></v-text-field>
                </v-col>
                <v-btn outlined @click="addToBeneficios('PRO')" color="green" dark block>
                  Agregar
                </v-btn>
              </v-row>
            </v-card-text>
            <!-- end seccion beneficios promociones -->
            <v-card-text v-if="tipoBeneficio == 'CB'">
              <v-row>
                <v-col md="12">
                  <h5>Beneficios CreditBook</h5>
                  <v-autocomplete v-model="beneficiosCreditBook.cb" label="Seleccione el tipo de CreditBook "
                    :items="cbList" item-value="id" item-text="nm">
                  </v-autocomplete>
                  <v-text-field v-model="beneficiosCreditBook.cnt" type="number" label="Cantidad Inicial" dense
                    required></v-text-field>
                </v-col>
                <v-btn outlined @click="addToBeneficios('CB')" color="green" dark block>
                  Agregar
                </v-btn>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col col="12" md="8">
          <v-card elevation="2" rounded="xl">
            <v-card-title> Beneficios actuales </v-card-title>

            <v-card-text>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Descripción</th>
                      <th class="text-left">Periodo</th>
                      <th class="text-left">Cantidad</th>
                      <th class="text-left">Estatus</th>
                      <th class="text-left">Opciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(beneficio, index) in AYB_Beneficios.Beneficios">
                      <tr :key="index">
                        <td>
                          {{ beneficio.Desc }}
                          {{
                            beneficio.Precio
                              ? "|| " +
                              beneficio.Precio.C +
                              " " +
                              beneficio.Precio.M
                              : ""
                          }}
                        </td>
                        <td>
                          {{
                            $pgsHelper.getById(
                              comp_periodos,
                              "Id",
                              beneficio.Periodo
                            ).Nombre
                          }}
                        </td>
                        <td>
                          {{
                            beneficio.Cantidad == Infinity
                              ? "Ilimitado"
                              : beneficio.Cantidad
                                ? beneficio.Cantidad
                                : "Ilimitado"
                          }}
                        </td>
                        <td>
                          <p v-if="beneficio.Activo" class="font-weight-black green--text">
                            Activo
                          </p>
                          <p v-if="!beneficio.Activo" class="font-weight-black red--text">
                            Inactivo
                          </p>
                        </td>
                        <td>
                          <v-btn @click="showModalEdit(beneficio, index)" x-small dark color="indigo">
                            Editar
                          </v-btn>
                          <v-btn v-if="beneficio.Activo" @click="desactivarBeneficio(index)" x-small dark
                            color="orange">
                            Desactivar
                          </v-btn>
                          <v-btn v-if="!beneficio.Activo" @click="activarBeneficio(index)" x-small dark color="blue">
                            Reactivar
                          </v-btn>
                          <v-btn @click="deleteBeneficio(index)" x-small dark color="red">
                            Eliminar
                          </v-btn>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </template>
              </v-simple-table>
              <v-btn @click="saveBeneficios()" color="green" dark block>
                Guardar Paquete de Beneficios
              </v-btn>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <modal ref="modalForm" :fullscreen="false" v-model="modals.showModal" :showFooter="false">
      <div>
        <v-card-title> Editar Beneficios </v-card-title>
        <!-- seccion beneficios tarifas -->
        <v-card-text v-if="beneficiosEditable.Tipo == 'RVA'">
          <v-row>
            <v-col md="12" cols="12">
              <h5>Beneficios de tarifas</h5>
              <v-select v-model="beneficiosEditable.Departamento" :items="RVA_Departamentos" @change="
                getTarifarios(beneficiosEditable.Departamento);
              getSubcategorias(beneficiosEditable.Departamento);
              " label="Departamentos Reserva"></v-select>
            </v-col>
            <v-col md="6" cols="12">
              <v-select v-model="beneficiosEditable.Tarifario" :items="Catalogos.tarifarios"
                label="Tarifarios"></v-select>
            </v-col>
            <v-col md="6" cols="12">
              <v-select v-model="beneficiosEditable.SubCategoria" :items="Catalogos.subcategorias" item-value="id"
                item-text="Nombre" label="Categoria de tarifas"></v-select>
            </v-col>
            <v-col cols="12">
              <v-switch inset v-model="beneficiosEditable.EsInvitado" :label="'Tarifa invitados'"></v-switch>
              <v-switch inset v-model="beneficiosEditable.Ilimitado" :label="'Ilimitado'"></v-switch>
              <v-text-field v-if="!beneficiosEditable.Ilimitado" v-model="beneficiosEditable.Cantidad" type="number"
                label="Cantidad" dense required></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <!-- end seccion beneficios tarifas -->
        <!-- seccion beneficios consumibles -->
        <v-card-text v-if="beneficiosEditable.Tipo == 'CON'">
          <v-row>
            <v-col md="12" cols="12">
              <h5>Beneficios consumibles</h5>
              <v-autocomplete label="Producto o Servicio" v-model="beneficiosEditable.ItemId"
                :items="PDV_Productos"></v-autocomplete>
            </v-col>
            <v-col md="12" cols="12">
              <v-select v-model="beneficiosEditable.Periodo" label="Periodo de Pago" :items="comp_periodos"
                item-text="Nombre" item-value="Id">
              </v-select>
              <v-switch v-model="beneficiosEditable.Ilimitado" inset :label="'Ilimitado'"></v-switch>
              <v-text-field v-if="!beneficiosEditable.Ilimitado" v-model="beneficiosEditable.Cantidad" type="number"
                label="Cantidad" dense required></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model="beneficiosEditable.Precio.C" type="number" label="Costo" dense
                required></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-select :items="Catalogos.monedas" item-value="id" item-text="Nombre"
                v-model="beneficiosEditable.Precio.M" label="Moneda" dense required></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <!-- end seccion beneficios consumibles -->
        <!-- seccion beneficios promociones -->
        <v-card-text v-if="beneficiosEditable.Tipo == 'PRO'">
          <v-row>
            <v-col md="12">
              <h5>Beneficios Promociones</h5>
              <v-autocomplete label="Promoción" v-model="beneficiosEditable.PromoId" item-value="id" item-text="Nombre"
                :items="Catalogos.promociones">
              </v-autocomplete>
            </v-col>
            <v-col md="12">
              <v-switch inset v-model="beneficiosEditable.Ilimitado" :label="'Ilimitado'"></v-switch>
              <v-text-field v-if="!beneficiosEditable.Ilimitado" v-model="beneficiosEditable.Cantidad" type="number"
                label="Cantidad" dense required></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <!-- end seccion beneficios promociones -->
        <v-card-text>
          <v-btn color="green" @click="editBeneficio(beneficiosEditable)" dark block>
            Guardar
          </v-btn>
        </v-card-text>
      </div>
    </modal>
  </div>
</template>

<script>
import TarifasClass from "../../../clases/Tarifa.js";
import Currency from "../../../clases/Currencies.js";
import MembresiaBeneficios from "../../../clases/Membresias/MembresiaBeneficios.js";
import modal from "../../MainComponents/modal.vue";
import PeriodosCobro from "../../../clases/Membresias/PeriodosCobro.js";
import MembresiaPlan from "../../../clases/Membresias/MembresiaPlan.js";
export default {
  name: "Beneficios",
  components: {
    modal
  },
  props: {
    idPlan: String
  },
  data() {
    return {
      cbList: [],
      showMenu: false,
      beneficiosType: [
        { value: "RVA", text: "Reserva" },
        { value: "CON", text: "Consumibles" },
        { value: "PRO", text: "Promociones" },
        //{value:"CB",text:"CreditBook"},
      ],
      modals: {
        showModal: false
      },
      currencyClass: Currency,
      tipoBeneficio: "RVA",
      planData: {},
      beneficioTarifas: {
        Cantidad: 0,
        RVA_Departamento: "",
        RVA_Subcategoria: "",
        Ilimitado: true,
        EsInvitado: false,
        RVA_Tarifario: "",
      },
      beneficioConsumible: {
        PDV_Producto: "",
        Ilimitado: false,
        Cantidad: "",
        Periodo: "",
        Precio: {
          C: 0,
          M: "MXN",
        },
      },
      beneficioPromociones: {
        Promocion: "",
        Ilimitado: false,
        Cantidad: "",
      },
      beneficiosCreditBook: {
        cb: "",
        cnt: 0
      },
      beneficiosEditable: {
        Ilimitado: false,
      },
      Catalogos: {
        tarifarios: [],
        subcategorias: [],
        promociones: [],
        monedas: [],
      },
      Beneficios: [],
      AYB_Beneficios: {},
    };
  },
  computed: {
    comp_periodos() {
      let data = PeriodosCobro.getPeriodosCobroList()
      data.unshift({ Nombre: "Global", Id: null })
      return data;
    },
    RVA_Departamentos() {
      let departamentos = this.$store.getters.getDepartamentos;
      departamentos.forEach((dep) => {
        (dep.text = dep.Nombre), (dep.value = dep.id);
      });
      return departamentos;
    },
    PDV_Productos() {
      let productos = this.$store.getters.getProductos;
      let productosComp = [];
      productos.forEach((element) => {
        if (!element.Dlat) {
          productosComp.push({
            value: element.id,
            text: element.Nombre,
            ...element,
          });
        }

      });
      return productosComp;
    },
  },
  methods: {
    async getTiposCb() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/TiposDineroElectronico"
        );
      this.cbList = this.$pgsHelper.ArrayObjectToArray(data.val());
    },
    showModalEdit(data, index) {
      data.Ilimitado = (data.Cantidad == null || data.Cantidad == Infinity) ? true : false;
      data.index = index;
      data.Cantidad = (data.Ilimitado) ? Infinity : data.Cantidad;
      if (data.Tipo == "RVA") {
        this.getTarifarios(data.Departamento);
        this.getSubcategorias(data.Departamento);
      }
      this.beneficiosEditable = JSON.parse(JSON.stringify(data))
      this.modals.showModal = true;
    },
    editBeneficio(data) {
      data.Cantidad = (data.Ilimitado) ? Infinity : Number(data.Cantidad);
      if (data.Tipo == "RVA") {
        let referenceName =
          this.$pgsHelper.getById(
            this.RVA_Departamentos,
            "id",
            data.Departamento
          ).Nombre +
          " - " +
          this.$pgsHelper.getById(
            this.Catalogos.tarifarios,
            "Id",
            data.Tarifario
          ).Nombre +
          " " +
          this.$pgsHelper.getById(
            this.Catalogos.subcategorias,
            "id",
            data.SubCategoria
          ).Nombre;
        data.Desc = referenceName;
      } else if (data.Tipo == "CON") {
        data.Desc = this.$pgsHelper.getById(
          this.PDV_Productos,
          "id",
          data.ItemId
        ).Nombre;
      } else if (data.Tipo == "PRO") {
        data.Desc = "Promoción - " + this.$pgsHelper.getById(
          this.Catalogos.promociones,
          "id",
          data.PromoId
        ).Nombre;
      }
      this.AYB_Beneficios.editBeneficio(data);
      this.modals.showModal = false;
      this.$forceUpdate();
    },
    deleteBeneficio(index) {
      this.$swal({
        title: "¿Deseas eliminar el beneficio?",
        text: "Sera eliminado permanentemente y afectara a las membresias que ya cuenten con este plan",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          this.AYB_Beneficios.removeBeneficio(index);
        }
      });
    },
    activarBeneficio(index) {
      this.AYB_Beneficios.activarBeneficio(index);
    },
    desactivarBeneficio(index) {
      this.AYB_Beneficios.desactivarBeneficio(index);
    },
    addToBeneficios(tipo) {
      let beneficio = {};
      if (tipo == "RVA") {
        beneficio = {
          Cantidad: this.beneficioTarifas.Ilimitado
            ? Infinity
            : Number(this.beneficioTarifas.Cantidad),
          Tipo: tipo,
          EsInvitado: this.beneficioTarifas.EsInvitado,
          Activo: true,
          Departamento: this.beneficioTarifas.RVA_Departamento,
          Tarifario: this.beneficioTarifas.RVA_Tarifario,
          SubCategoria: this.beneficioTarifas.RVA_Subcategoria,
          Desc: "",
        };
        let referenceName =
          this.$pgsHelper.getById(
            this.RVA_Departamentos,
            "id",
            this.beneficioTarifas.RVA_Departamento
          ).Nombre +
          " - " +
          this.$pgsHelper.getById(
            this.Catalogos.tarifarios,
            "Id",
            this.beneficioTarifas.RVA_Tarifario
          ).Nombre +
          " " +
          this.$pgsHelper.getById(
            this.Catalogos.subcategorias,
            "id",
            this.beneficioTarifas.RVA_Subcategoria
          ).Nombre;
        beneficio.Desc = referenceName;
      } else if (tipo == "CON") {
        this.beneficioConsumible.Precio.C = Number(this.beneficioConsumible.Precio.C)
        beneficio = {
          Cantidad: this.beneficioConsumible.Ilimitado
            ? Infinity
            : Number(this.beneficioConsumible.Cantidad),
          Tipo: tipo,
          Periodo: this.beneficioConsumible.Periodo,
          PeriodoName: this.$pgsHelper.getById(
            this.comp_periodos,
            "Id",
            this.beneficioConsumible.Periodo
          ).Nombre,
          ItemId: this.beneficioConsumible.PDV_Producto,
          Precio: JSON.parse(JSON.stringify(this.beneficioConsumible.Precio)),
          Activo: true,
          Desc: this.$pgsHelper.getById(
            this.PDV_Productos,
            "id",
            this.beneficioConsumible.PDV_Producto
          ).Nombre,
        };
      } else if (tipo == "PRO") {
        beneficio = {
          Cantidad: this.beneficioPromociones.Ilimitado
            ? Infinity
            : Number(this.beneficioPromociones.Cantidad),
          Tipo: tipo,
          Activo: true,
          PromoId: this.beneficioPromociones.Promocion,
          Desc:
            "Promoción - " +
            this.$pgsHelper.getById(
              this.Catalogos.promociones,
              "id",
              this.beneficioPromociones.Promocion
            ).Nombre,
        };
      } else if (tipo == "CB") {
        console.log("agregando cb")
      }
      this.AYB_Beneficios.addBeneficio(beneficio);
    },
    async getTarifarios(dep) {
      let tarifarios = await TarifasClass.getMixTarifasCombo(
        dep
      );
      tarifarios.forEach((element) => {
        element.value = element.Id;
        element.text = element.Nombre;
      });
      this.Catalogos.tarifarios = tarifarios;
    },
    async getSubcategorias(dep) {
      this.horarios = [];
      /* obtiene el listado de temporadas activas en el sistema  */
      const data = await this.$store.getters.getFirebaseApp.database
        .queryBuilder(
          "RVA/Tarifas/" +
          dep +
          "/SubCategorias"
        )

      if (!data.exists()) {
        return false;
      }

      this.Catalogos.subcategorias = [];
      this.Catalogos.subcategorias = this.$pgsHelper.ArrayObjectToArray(
        data.val()
      );
    },
    async getPromociones() {
      const firestore = this.$store.getters.getFirebaseApp.firestore
      const snapshot = await firestore
        .queryBuilder("PDV_Promociones",
          [
            firestore.where("Membresia", "==", true),
            firestore.where("Tenant", "==", this.$store.getters.getFirebaseApp.tenant)
          ]
        )
      let data = snapshot.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      })
      let sortPromo = this.$_.orderBy(data, "Peso", "desc");
      this.Catalogos.promociones = sortPromo;
    },
    async saveBeneficios() {
      this.$swal({
        title: "¿Deseas guardar las modificaciones a los beneficios?",
        text: "",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          let route = "MBS-Planes-createBeneficio";
          if (this.AYB_Beneficios.Id) {
            route = "MBS-Planes-updateBeneficio";
          }
          return await this.$store.getters.getFirebaseApp.fba
            .call(route, this.AYB_Beneficios)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$pgsHelper.log(result.value);
            this.$swal({
              title: "Guardado",
              text: "Los beneficios se guardaron correctamente",
              icon: "success",
            }).then(async () => {
              this.AYB_Beneficios = await MembresiaBeneficios.getByPlan(
                this.idPlan
              );
            });
          } else {
            this.$swal(
              "Error saving beneficios",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
  },
  beforeMount: function () { },
  mounted: async function () {
    this.Catalogos.monedas = this.currencyClass.getCurrencies();
    /* si el plan tiene bdocumento de beneficio lo recupera y si no tiene, crea una instancia de la clase */
    this.AYB_Beneficios = await MembresiaBeneficios.getByPlan(
      this.idPlan
    );
    this.planData = await MembresiaPlan.getById(this.idPlan)
    if (!this.AYB_Beneficios) {
      this.AYB_Beneficios = new MembresiaBeneficios({
        Plan: this.idPlan,
        Beneficios: [],
      });
    }
    this.getPromociones();
    this.getTiposCb()
  },
};
</script>
